<template>
   <b-list-group>
        <b-list-group-item v-for="(item, key) in users" :key="key" :class="item.hidden?'displaynone':'listitem'">
            <div class="w-100 d-flex justify-content-between align-items-center" v-if="!item.hidden">
                <div>{{ item.isguide ? 'Guida:' : '' }}&nbsp;{{ item.screen_name }}</div>
                <div>
                    <b-icon-person-fill :variant="item.online?'success':'danger'"></b-icon-person-fill>
                    <b-icon-volume-up v-if="item.isStreaming"></b-icon-volume-up>
                    <b-icon-camera-video v-if="item.hasvideo"></b-icon-camera-video>
                    <b-icon-question-octagon-fill v-if="item.request" variant="warning" @click="startusercohost(key)"></b-icon-question-octagon-fill>
                    <b-icon-x-octagon-fill v-if="host" variant="danger" @click="stopusercohost(key)"></b-icon-x-octagon-fill>
                </div>
            </div>
            <div class="w-100">
                <div :class="item.hasvideo?'remote-stream':''" :id="'remote_stream_' + item.divuid"></div>
            </div>
        </b-list-group-item>
   </b-list-group>
</template>

<script>
    export default {
        name: "UserList",
        props: {
            host: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return{
                selecteduser: null,
                users: {}
            }
        },
        methods:{
            addUser: function (_uid, _screenname, _hidden=false){
                if(!(_uid in this.users)){
                    let user = {
                        uid: _uid,
                        divuid: this.cleanupUserId(_uid),
                        screen_name: _screenname.replace('$', ''), // this.getScreenName(_uid),
                        isStreaming: false,
                        hasvideo: false,
                        online: true,
                        request: false,
                        hidden: _hidden,
                        isguide: _uid.search('$') === 0
                    }
                    this.$set(this.users, _uid, user);
                    if(user.isguide) {
                        this.$emit('guide-online');
                    }
                } else {
                    this.users[_uid].online= true;
                }
            },
            cleanupUserId: function (_id){
              return _id.replace('#', '_').replace('$', '');
            },
            setUserStreaming: function (_stream, _isstreaming=true) {
                if(_stream){
                    let id = _stream.getId();
                    if(id in this.users){
                        this.users[id].isStreaming = _isstreaming;
                        if(_isstreaming){
                            _stream.play("remote_stream_" + this.cleanupUserId(id));
                            if(_stream.hasVideo()){
                                this.users[id].hasvideo = true;
                            }
                            if(this.users[id].isguide) {
                                this.$emit('guide-streaming');
                            }
                        } else {
                            _stream.stop("remote_stream_" + this.cleanupUserId(id));
                            this.users[id].hasvideo = false;
                            // cleanup remote stream
                            console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&', "#remote_stream_" + this.cleanupUserId(id));
                            const div = document.querySelector("#remote_stream_" + this.cleanupUserId(id));
                            [].slice.call(div.children).forEach(function(child) {div.removeChild(child)})
                            if(this.users[id].isguide) {
                                this.$emit('guide-end-streaming');
                            }
                        }
                    }
                }
            },
            setUserOffline(id){
                if(id in this.users){
                    this.users[id].isStreaming = false;
                    this.users[id].request = false
                    this.users[id].online = false;
                    this.users[id].hasvideo = false;
                    const div = document.querySelector("#remote_stream_" + this.cleanupUserId(id));
                    [].slice.call(div.children).forEach(function(child) {div.removeChild(child)})
                    if(this.users[id].isguide) {
                        this.$emit('guide-offline');
                    }
                }
            },
            setUserNotification(_user){
                if(_user in this.users){
                    this.users[_user].request = true;
                    console.log(this.users[_user], this.users[_user].request);
                }
            },
            setUsersOffline(){
                for (let key of Object.keys(this.users)) {
                    this.setUserOffline(key);
                }
            },
            startusercohost: function(_key){
                this.$emit('usercohost', _key, true);
                this.users[_key].request = false;
            },
            stopusercohost: function(_key){
                this.$emit('stopusercohost', _key, false);
                this.users[_key].request = false;
            }
        }
    }
</script>

<style scoped>

    .listitem {
        padding: 5px;
    }

    .displaynone{
        display:none;
    }

    .remote-stream{
        width:100%;
        height:100%;
        margin: auto;
    }

    /deep/ video {
        position: unset !important;
    }

</style>
